import { defaultTo } from 'lodash';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IVisitSalesItemPublicModel extends ISyncModel {
  salesItemCode: string;
  salesItemDescription: string;
  salesItemName: string;
  salesItemFullName: string;
  salesItemOptionName: string;
  salesItemOptionDisplayName: string;
  salesItemPrice: number;
  invoicePrice: number | undefined;
  invoiceUnitPrice: number | undefined;
  salesPackageId: number | undefined;
  salesPackageName: string | undefined;
  salesPackagePrice: number | undefined;
  quantity: number | undefined;
  salesItemUnitPrice: number | undefined;
  estimateQuantityLow: number | undefined;
  estimateQuantityHigh: number | undefined;
  showQuantityRanges: boolean | undefined;
  salesItemOptionAllowPartialQuantities: boolean | undefined;
  salesItemOptionAllowQuantityChanges: boolean | undefined;
  salesItemOptionAllowQuantityRanges: boolean | undefined;
  salesItemOptionAllowUserEnteredPrice: boolean | undefined; // defines if the Sales Item Option allows the user to dictate the price of the item once it is in a visit.  Whatever price that is in the pricing rule will initially be set when items are added to a visit, but the pricing engine in the platform will not attempt to set/reset the price at any time.
  salesItemOptionMinimumQuantity: number | undefined;
  salesItemOptionMaximumQuantity: number | undefined;
  dispensingFee: number | undefined;
  wasDeclinedByClient: boolean;
  wasDeclinedByVeterinarian: boolean;
  isPending: boolean;
  given: boolean;
  isDiscountItem: boolean;
  isPackageAddOn: boolean;
  wasPreviouslyPended: boolean;
  packageAddOnPrice: number | undefined; //UI Only
  upgradingPrice: number | undefined; //UI Only
  isPackageUpgrade: boolean;
}

export class VisitSalesItemPublicModel
  extends SyncModel
  implements IVisitSalesItemPublicModel
{
  salesItemCode: string;
  salesItemDescription: string;
  salesItemName: string;
  salesItemFullName: string;
  salesItemOptionName: string;
  salesItemOptionDisplayName: string;
  salesItemPrice: number;
  invoicePrice: number;
  invoiceUnitPrice: number;
  salesPackageId: number | undefined;
  salesPackageName: string | undefined;
  salesPackagePrice: number | undefined;
  quantity: number;
  salesItemUnitPrice: number;
  estimateQuantityLow: number | undefined;
  estimateQuantityHigh: number | undefined;
  showQuantityRanges: boolean;
  salesItemOptionAllowPartialQuantities: boolean;
  salesItemOptionAllowQuantityChanges: boolean;
  salesItemOptionAllowQuantityRanges: boolean;
  salesItemOptionAllowUserEnteredPrice: boolean; // defines if the Sales Item Option allows the user to dictate the price of the item once it is in a visit.  Whatever price that is in the pricing rule will initially be set when items are added to a visit, but the pricing engine in the platform will not attempt to set/reset the price at any time.
  salesItemOptionMinimumQuantity: number;
  salesItemOptionMaximumQuantity: number;
  dispensingFee: number | undefined;
  wasDeclinedByClient: boolean;
  wasDeclinedByVeterinarian: boolean;
  isPending: boolean;
  given: boolean;
  isDiscountItem: boolean;
  isPackageAddOn: boolean;
  packageAddOnPrice: number | undefined; //UI Only
  upgradingPrice: number | undefined; //UI Only*/
  wasPreviouslyPended: boolean;
  isPackageUpgrade: boolean;

  constructor(params: IVisitSalesItemPublicModel) {
    super(params);
    this.salesItemCode = params.salesItemCode;
    this.salesItemDescription = params.salesItemDescription;
    this.salesItemName = params.salesItemName;
    this.salesItemFullName = params.salesItemFullName;
    this.salesItemOptionName = params.salesItemOptionName;
    this.salesItemOptionDisplayName = params.salesItemOptionDisplayName;
    this.salesPackageId = params.salesPackageId;
    this.salesItemPrice = params.salesItemPrice;
    this.salesPackageName = params.salesPackageName;
    this.salesPackagePrice = params.salesPackagePrice;
    this.quantity = defaultTo(params.quantity, 1);
    this.salesItemUnitPrice = defaultTo(
      params.salesItemUnitPrice,
      params.salesItemPrice,
    );
    this.estimateQuantityLow = params.estimateQuantityLow;
    this.estimateQuantityHigh = params.estimateQuantityHigh;
    this.showQuantityRanges = defaultTo(params.showQuantityRanges, false);
    this.salesItemOptionAllowPartialQuantities = defaultTo(
      params.salesItemOptionAllowPartialQuantities,
      false,
    );
    this.salesItemOptionAllowQuantityChanges = defaultTo(
      params.salesItemOptionAllowQuantityChanges,
      false,
    );
    this.salesItemOptionAllowQuantityRanges = defaultTo(
      params.salesItemOptionAllowQuantityRanges,
      false,
    );
    this.salesItemOptionAllowUserEnteredPrice = defaultTo(
      params.salesItemOptionAllowUserEnteredPrice,
      false,
    );
    this.salesItemOptionMinimumQuantity = defaultTo(
      params.salesItemOptionMinimumQuantity,
      1,
    );
    this.salesItemOptionMaximumQuantity = defaultTo(
      params.salesItemOptionMaximumQuantity,
      1,
    );
    this.wasDeclinedByClient = defaultTo(params.wasDeclinedByClient, false);
    this.dispensingFee = params.dispensingFee;
    this.wasDeclinedByVeterinarian = defaultTo(
      params.wasDeclinedByVeterinarian,
      false,
    );
    this.isPending = defaultTo(params.isPending, false);
    this.given = defaultTo(params.given, false);
    this.isDiscountItem = defaultTo(params.isDiscountItem, false);
    this.invoicePrice = defaultTo(params.invoicePrice, params.salesItemPrice);
    this.invoiceUnitPrice = defaultTo(
      params.invoiceUnitPrice,
      defaultTo(params.salesItemUnitPrice, params.salesItemPrice),
    );
    this.isPackageAddOn = defaultTo(params.isPackageAddOn, false);
    this.isPackageUpgrade = defaultTo(params.isPackageUpgrade, false);
    this.wasPreviouslyPended = defaultTo(params.wasPreviouslyPended, false);
  }
}
